import './App.css';
import { Button, Grid } from '@mui/material';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import React, { useState } from 'react';
import AddLayoff from './AddLayoffs';
import LayOffDataTable from './LayOffDataTable';
import { auth } from './firebase';

import MenuAppBar from './MenuAppBar';

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });

function App() {
  const [user, setUser] = useState({});
  const googleHandler = async () => {
    provider.setCustomParameters({ prompt: 'select_account' });
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const { user } = result;
        setUser({ name: user.displayName, email: user.email });
        // redux action? --> dispatch({ type: SET_USER, user });
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const { email } = error;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  };

  const logout = () => {
    signOut(auth);
  };

  return (
    <>
      <MenuAppBar logout={logout} />

      <Grid
        container
        alignItems="center"
        direction="column"
        rowSpacing={2}
      >
        <Grid item>
          {!!user && (
          <div>
            Hello,
            {' '}
            {user.name}
          </div>
          )}
        </Grid>
        {Object.keys(user).length !== 0
          ? (
            <Grid item>
              <AddLayoff user={user} />
            </Grid>
          )
          : (
            <Grid item>
              <Button onClick={googleHandler}>Login</Button>
            </Grid>
          )}
        <Grid item>
          <LayOffDataTable />
        </Grid>
      </Grid>
    </>
  );
}

export default App;
